const criteoAddManipulation = function () {
    let $criteoProductBtn = $('.creative_product-btn .criteo-btn');
    let $criteoProductTile = $('.criteo-container__tiles .default-product-tile');

    function showCriteoProduct() {
        for (let i = 0; i < $criteoProductBtn.length; i++) {
            let criteoSelectProduct = $criteoProductBtn[i];
            let activeProductBtn = $(criteoSelectProduct).hasClass('active');
            if (activeProductBtn) {
                $criteoProductTile.eq(i).addClass('criteo-active-tile');
                // Force check of visible fraction which is normally triggered on resize/scroll only
                $criteoProductTile.fracs('check');
            }
        }
    }

    const $criteoButterflyContainer = $('.criteo-container');
    if ($criteoButterflyContainer) {
        const formatLevelOnClickBeacon = $criteoButterflyContainer.data('criteo-butterfly-format-on-click-beacon');
        const formatLevelOnLoadBeacon = $criteoButterflyContainer.data('criteo-butterfly-format-on-load-beacon');
        const formatLevelOnViewBeacon = $criteoButterflyContainer.data('criteo-butterfly-format-on-view-beacon');

        CriteoButterflyTracker.sendFormatOnLoadEvent(formatLevelOnLoadBeacon);
        CriteoButterflyTracker.registerFormatOnViewEvent($criteoButterflyContainer, formatLevelOnViewBeacon);

        $criteoProductBtn.on('click', function () {
            $criteoProductBtn.removeClass('active');
            $(this).addClass('active');
            $criteoProductTile.removeClass('criteo-active-tile');
            showCriteoProduct();
        });

        const callToActionButton = $criteoButterflyContainer.find('.criteo-call-to-action');
        if (callToActionButton) {
            callToActionButton.click(function () {
                CriteoButterflyTracker.sendFormatOnClickEvent(formatLevelOnClickBeacon);
            });
        }
    }

};

$(document).ready(function () {
    criteoAddManipulation();
});